export const invoiceTemplates = {
  actions: {
    create: 'Créer un modèle de facture',
    createInvoice: 'Créer une facture',
    delete: 'Supprimer',
    details: 'Plus de détails',
    edit: 'Modifier',
    pause: 'Mettre en pause',
    unpause: 'Mettre en ligne',
  },
  alerts: {
    successCreated: 'Votre modèle de facture a été créé.',
    successDeleted: 'Votre modèle de facture a été supprimé.',
    successUpdated: 'Votre modèle de facture a été modifié.',
  },
  breadcrumb: {
    create: 'Créer un modèle de facture',
    noTitle: 'Sans titre',
    overview: 'Modèles de facture',
  },
  breadcrumbs: {
    index: 'Tous les modèles de facture',
    show: 'Détails du modèle de facture',
  },
  createEdit: {
    blocker: {
      create: 'Voulez-vous vraiment quitter cette page ? Votre modèle de facture n’a pas été enregistré.',
      edit: 'Voulez-vous vraiment quitter cette page ? Vos modifications n’ont pas été enregistrées.',
    },
    fields: {
      interval: {
        label: 'Créer périodiquement',
      },
      nextInvoiceAt: {
        label: 'Prochaine facture',
      },
      paymentTerm: {
        helpText: 'La date d’échéance sera fixée {{days}} jours après la date de la facture.',
        helpTextEndOfMonth: 'La date d’échéance sera fixée {{days}} jours après la fin du mois de la date de la facture.',
      },
    },
    header: {
      title: {
        create: 'Nouveau modèle de facture',
        edit: 'Modifier le modèle de facture',
      },
    },
    preview: 'Aperçu de la facture',
    unpauseModal: {
      description: 'Votre modèle de facture n’est pas actif.\n<break/>Le réactiver ? La prochaine facture sera créée le {{nextInvoiceAt}}.',
      keepPaused: 'Laisser inactif',
      title: 'Reprendre les factures périodiques',
      unpause: 'Réactiver',
    },
  },
  deleteModal: {
    description: 'Voulez-vous vraiment supprimer ce modèle de facture ?',
    submit: 'Supprimer le modèle de facture',
    title: 'Supprimer le modèle de facture',
  },
  details: {
    error: {
      title: 'Erreur lors du chargement de votre modèle de facture.',
    },
    intervalStatusTooltip: {
      Live: 'Votre modèle de facture est actif, les factures sont créées périodiquement.',
      Paused: 'Votre modèle de facture n’est pas actif, vos factures ne sont pas créées périodiquement.',
    },
    invoices: {
      noInvoicesMessage: 'Aucune facture n’a encore été créée avec ce modèle de facture.',
      title: 'Factures',
      titleWithCount: 'Factures ({{amount}})',
    },
    stats: {
      nextInvoice: {
        label: 'Prochaine facture',
        tooltip: 'Ce jour-là, un nouveau brouillon de facture est automatiquement créé pour vous sur la base de ce modèle.',
      },
      recurring: {
        label: 'Créer périodiquement',
        tooltip: 'La fréquence à laquelle vos factures sont créées.',
      },
      totalAdvantage: {
        label: 'Avantage total',
        tooltip: 'L’avantage total de toutes les factures que vous avez créées avec ce modèle.',
      },
      totalInvoices: {
        label: 'Nombre de factures',
        tooltip: 'Nombre total de factures périodiques créées avec ce modèle.',
      },
    },
    summary: {
      title: 'Aperçu',
    },
  },
  overview: {
    columns: {
      client: 'Client',
      nextInvoiceAt: 'Prochaine facture',
      title: 'Titre',
      total: 'Total (hors TVA)',
      type: 'Type',
    },
    error: {
      title: 'Erreur lors du chargement de vos modèles de facture.',
    },
    header: {
      title: 'Modèles de facture',
    },
  },
  terminology: {
    interval: {
      cases: {
        Disabled: 'Désactivé',
        Monthly: 'Mensuel',
        Quarterly: 'Trimestriel',
        Weekly: 'Hebdomadaire',
      },
    },
    intervalStatus: {
      cases: {
        Live: 'En ligne',
        Paused: 'En pause',
      },
    },
    invoiceTemplate: 'Modèle de facture',
    templateType: {
      cases: {
        Manual: 'Manuel',
        Recurring: 'Périodique',
      },
    },
  },
};
